/*
* @Author: huangshuo
* @Date: 2020-2-18 11:49:00
*/
<template>
  <div
    class="filelist-item"
    :class="[`isfolder-${currentData.isDir}`, {'item-selected': currentData.checked}]"
  >
    <!--列表主题-->
    <div
      ref="fileItem"
      class="filelist-item-inner card-mode"
      :class="[{'hover': isShowOperation}, {'filelist-item-inner-active':currentData.checked}]"
      @mouseenter="mouseenterHandler"
      @mouseleave="mouseleaveHandler"
      @dblclick="dblclickHandler"
      @mouseup="clickHandler"
    >
      <div class="clearfloat">
        <!-- 大图模式下的文件 -->
        <div
          ref="bgDisplay"
          class="icon-mode-bg"
        >
          <!--非图片,显示svg-->
          <svg
            v-if="!picRouter"
            ref="bgsvg"
            class="file-icon"
          >
            <use
              ref="fileicon"
              :xlink:href="getIcon(currentData)"
            />
          </svg>
          <!--图片模式, 显示图片缩略图-->
          <img
            v-if="picRouter"
            ref="bigImg"
            class="icon-view-thumbnail"
            :src="picRouter"
            @error.once="iconErrorHandler"
          >
        </div>

        <!-- 文件列表复选框 -->
        <div
          v-if="headerInfo.checkbox"
          ref="checkbox"
          class="box-checkbox"
          :class="isDisabled? 'checkbox-disabled-div':''"
        >
          <span
            class="box-checkbox-inner"
            :class="[isDisabled? '': currentData.checked? 'checkbox-checked': 'checkbox-uncheck', isDisabled? 'checkbox-disabled-click':'']"
          />
        </div>

        <!-- 列表每一条记录的内容 -->
        <div
          ref="fileitem"
          class="filelist-item-inner-blocks filelist-item-inner-blocks-nodir"
        >
          <template v-for="(list, j) in currentData.data">
            <!-- 文件名里的内容 -->
            <div
              v-if="list.type == 'file'"
              ref="fileinfo"
              :key="j"
              :class="`item-${j} filelist-icon ${list.class} file-item-info`"
            >
              <!--文件列表内容区域, 删除了action-list.action的值永远为undefined-->
              <div
                ref="filrArea"
                :class="'file-area'"
              >
                <!--列表信息部分-->
                <div
                  ref="fileInfoSpan"
                  class="file-info"
                >
                  <span class="file-name">
                    <!--如果文件不存在，显示tooltipsj进行提示,否则显示a链接进行展示-->
                    <el-tooltip
                      v-if="noExist"
                      class="item"
                      effect="dark"
                      :content="currentData.is_dir?$t('文件夹不存在'):$t('文件不存在')"
                      placement="top"
                    >
                      <a
                        v-if="!list.showRename"
                        ref="name"
                        class="display-name"
                        :title="list.value | filterHtml"
                        v-html="formateName(list.value)"
                      />
                    </el-tooltip>
                    <a
                      v-else-if="!list.showRename"
                      ref="name"
                      class="display-name card-name"
                      :class="[currentData.is_dir? 'dir-name' : haveVirus? 'has-virus-icon':'no-virus-icon', currentData.canPreivew? '':currentData.is_dir?'':'no-preview' ]"
                      :title="list.value | filterHtml"
                      v-html="formateName(list.value)"
                    />
                    <!--大图模式下显示文件病毒的方式-->
                    <span
                      v-if="!list.showRename && haveVirus"
                      class="virus-icon"
                      :style="{visibility: (haveVirus && !currentData.is_dir)? 'visible':'hidden'}"
                    >{{ $t('病毒') }}</span>
                  </span>
                  {{ list.others || '' }}
                </div>
              </div>
            </div>
            <!--显示日期时间和文件大小-->
            <div
              v-else
              :key="j"
              :class="`item-${j} ${list.class} file-item-info`"
              :title="list.title"
              v-html="list.value"
            />

            <!--文件其他图标属性的插槽-->
            <slot
              v-if="isShowIconGroup && j=='0'"
              name="icongroup"
              class="custom-icon"
              :data="{currentData, index, otherData: $data}"
            />

            <!--添加操作项插槽-->
            <slot
              v-if="list.type == 'file'"
              name="operation"
              :data="{currentData, index, operationState, otherData: $data}"
            />
          </template>

          <!--大图模式下的...更多-->
          <i
            v-if="showFakeMoreIcon"
            class="icon icon-i-more fake"
            :class="{'rename-fake':currentData.data[0].showRename}"
          >
            <svg class="item-icon item-icon-more-svg">
              <use xlink:href="#more" />
            </svg>
          </i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import qs from 'qs'
import mixin from './mixin.js'

export default {
  components: {},
  mixins: [mixin],
  props: {
    // 显示更多按钮
    showMore: Boolean,
  },
  data() {
    return {
      picTimer: null, // 图片加载的缓冲时间
      picRouter: '', // 图片缩略图的路径
      showFakeMoreIconFlag: true, // 显示更多按钮的图标
    }
  },
  computed: {
    /**
         * 操作按钮的状态
         */
    operationState() {
      return this.isShowOperation
    },
    /**
         *大图模式下显示更多...
         */
    showFakeMoreIcon() {
      return this.showFakeMoreIconFlag && this.showMore
    },
  },
  watch: {
    /**
         * 监听到当前对象发生变化，重新去请求图片缩略图的路径
         */
    currentData(val, old) {
      this.picRouter = this.getPicRouter()
    },
    /**
         * 显示操作icon
         */
    operationState(val) {
      // 真实的消失，占位icon就要展示
      if (!val) this.showFakeMoreIconFlag = true
    },
  },
  mounted() {},
  created() {
    // 设置图片加载的缓存时间
    this.picTimer = setTimeout(() => {
      this.picRouter = this.getPicRouter()
    }, 1500)
  },
  beforeDestroy() {
    // 消除事件
    clearTimeout(this.picTimer)
  },
  methods: {
    /**
         * 鼠标经过事件
         */
    mouseenterHandler() {
      // 这个hoverNeid抛出后,在重新传入，与当前currentData.neid做对比
      this.$emit('setHoverNeid', this.currentData)
      // 隐藏...图标
      this.showFakeMoreIconFlag = false
      // 大图模式一直显示菜单
      this.showOperation = true
    },
    /**
         * 鼠标离开事件
         */
    mouseleaveHandler(e) {
      // 遮罩部分
      if (this.isShowMask) return
      // 显示..图标
      this.showFakeMoreIconFlag = true
      // 隐藏操作项目
      this.showOperation = false
    },
    /**
         * 设置图片异常后的图标样式
         */
    iconErrorHandler() {
      this.picRouter = require('../../../../static/image/delete.svg')
    },
    /**
         * 获取大图模式下的图片路径（缩略图）
         */
    getPicRouter() {
      if (this.currentData.is_dir) return false
      if (!this.currentData.mime_type) {
        this.currentData.mime_type = this.currentData.data[0].mime_type
      }
      const isPic = this.currentData.mime_type.indexOf('image') > -1
      if (!isPic || this.currentData.preview_url === '') return false
      // 返回大图模式（缩略图的）地址
      const picURL = this.currentData.preview_url
      const pichost = picURL.split('?')[0]
      const picUrlParams = picURL.split('?')[1]
      const picUrlParamsObj = {
        ...qs.parse(picUrlParams),
        width: '320',
        height: '160',
      }
      return `${pichost}?${qs.stringify(picUrlParamsObj)}`
    },
  },
}
</script>
<style lang="less" scoped>

//大图模式...图标的位置
.filelist-item{
  .icon-i-more{
    &.fake{
      float: right;
      margin-right: 12px;
      margin-top: 0;
    }
    &.rename-fake{
      margin-top: 19px
    }
  }
  .card-mode{
    .icon-i-more{
      &.fake{
        margin-top: 11px;
      }
      &.rename-fake{
        margin-top: 0px
      }
    }
  }
}
//名称字体大小
.card-name {
  font-size:14px;
}

//大图模式...图标
.item-icon-more-svg{
  width:16px;
  height:16px;
  position: relative;
  top: 4px;
  left: 4px;
}

//checkbox禁止点击
.checkbox-disabled-click {
  pointer-events:none;
  border:1px solid #C1C7CD;
  background-color:#F6F7FA;
}
//禁止点击checkbox外层div,防止出现问题
.checkbox-disabled-div {
  pointer-events:none;
}

//大图模式的样式(待修改)
.list-wrapper.card-view {
  .filelist-header{
    margin-bottom: 6px;
  }
  @media only screen and (min-width: 1700px) {
    .filelist-item {
      width: 20% !important;
    }
  }
  @media only screen and (min-width: 1408px) and (max-width: 1700px) {
    .filelist-item {
      width: 25% !important;
    }
  }
  @media only screen and (max-width: 1408px) {
    .filelist-item {
      width: 33.3% !important;
    }
  }
  @media only screen and (max-width: 1180px) {
    .filelist-item {
      width: 50% !important;
    }
  }
  .filelist-item:hover {
    background-color: #ffffff !important;
  }
  .filelist-item {
    width: 20%;
  }
  .filelist-item {
    padding: 6px 6px;
    float: left;
    box-sizing: border-box;
    transition: width 1s;
    #new-file {
      .file-area{
        height: 66px;
        line-height: 66px;
        padding: 0 24px;
        .file-icon {
          display: inline-block;
          height: 34px;
          margin-left: 4px;
          vertical-align: middle;
          width: 40px;
        }
        input{
          width: calc(100% - 60px)
        }
      }
      .card-mode .file-area{
        height: 80px;
        line-height: 80px;
        input{
          width: 100%;
        }
      }
    }
    .checkmark {
      border: 1px #157BF8 solid !important;
    }
    /*
                *大图模式下的更多按钮要加hover态
                */
    .icon-i-more{
      width: 24px;
      height: 24px;
      position: relative;
      top: -5px;
    }
    /**
                 *  大图模式下的文件会用到，非目录
                 */
    .mode-panel-file:hover, .filelist-item-inner:hover {
      border: 1px #157BF8 solid;
      .checkbox-uncheck{
        border: 1px solid #2c7df1
      }
    }
    /**
                 *大图模式下文件选中转台
                 */
    .filelist-item-inner-active {
      border: 1px #157BF8 solid !important;
    }

    .mode-panel-file, .filelist-item-inner {
      float: left;
      position: relative;
      border: 1px #eaeaea solid;
      box-sizing: border-box;
      width: 100%;
      min-height: 66px;
      height: 100%;
      border-radius: 2px;
      .filelist-item-inner-blocks{
        font-size: 12px;
        overflow: hidden;
      }
      .filelist-item-inner-blocks-nodir{
        font-size: 12px;
        overflow: hidden;
        height:80px;
      }
      .icon-mode-bg{
        width:100%;
        height: 150px;
        //display: grid;
        background-color: #f3f5f8;
        border-bottom: 1px solid #eaeaea;
        overflow: hidden;
        position: relative;
        .icon-view-thumbnail{
          width: 100%;
          margin: 0 auto;
          cursor: pointer;
          height:100%;
        }
      }
      .card-mode-footer{
        position: relative;
        height: 64px;

      }
      .box-checkbox {
        position: absolute;
        top: 8px;
        left: 8px;
        width: unset;
        line-height: unset;
        height: unset;
      }
      .file-icon {
        float: left;
        width: 40px;
        height: 34px;
        margin: 14px 7px 0 30px;
        display: inline-block;
        background-color: transparent;
        background-repeat: no-repeat;
        vertical-align: middle;
      }
      .display-name {
        top: 14px !important;
        display: inline-block;
        max-width: 65%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
        color: #050f28;
        height: 22px;
        position: relative;
      }

      /**重新设置有病毒图标和没病毒图片的文件名称长度比率 */
      .has-virus-icon{
        max-width: 58%;
      }

      .no-virus-icon{
        max-width: 76%;
      }

      .file-absolute {
        display: inline-block;
        position: absolute;
        top: 30px;
        height: 20px;
        line-height: 20px;
        .favorite-icon {
          vertical-align: bottom;
          position: relative;
          display: inline-block;
          visibility: hidden;
          width: 16px;
          height: 16px;
          margin-left: 4px;
          //background: url(~image/favoriteBox/star.svg) no-repeat;
          cursor: pointer;
          &.favorited {
            display: inline-block;
            visibility: visible;
            //background-image: url(~image/favoriteBox/starl.svg);
          }
        }
        .lock-icon {
          vertical-align: bottom;
          position: relative;
          display: none;
          width: 20px;
          height: 20px;
          //background: url(~image/file-list/file-operate.png) -45px -85px;
          &.locked {
            display: inline-block;
          }
        }
        .edit-ol-icon {
          vertical-align: bottom;
          position: relative;
          top: 2px;
          display: none;
          width: 18px;
          height: 18px;
          //background: url(~image/file-list/edit-ol.gif) no-repeat;
          cursor: pointer;
          &.edited {
            display: inline-block
          }
        }
      }
      .update-date-updator, .update-size, .recent-update-date, .recent-update-size{
        position: absolute;
        color: #a1a1a1;
        display: block;
      }
      .update-date-updator{
        left: 77px;
        top: 35px;
      }
      .update-size{
        display: none;
      }
      .file-more {
        position: absolute;
        right: 14px;
        top: 18px;
      }
      .file-operate {
        float: right;
        margin-right: 12px;
        .link, .download, .commonLink {
          display: none;
        }
        .more > i {
          font-size: 24px;
        }
        .card-mode-rename-more{   //大图模式重命名时 ...样式修改
          position: relative;
          bottom: 30px;
        }
      }
      ul.file-operate-options{
        position: absolute;
        margin: 0px;
        list-style-type: none;
        z-index: 1000;
        min-width: 190px;
        background: #FFFFFF;
        border: 1px solid #E8EBEF;
        box-shadow: 0 4px 14px 0 rgba(5,15,40,0.10);
        border-radius: 2px;
        padding: 8px 0;
        &.show-menu{
          display: block;
        }
        li.menu-item {
          min-width: 158px;
          padding: 8px 16px;
          color: #282e3d;
          cursor: pointer;
          box-sizing: border-box;
          line-height: 28px;
          &#auth,
          &#history,
          &#delete, &#favorite {
            border-top: 1px solid #EAEAEA
          }
          &#favorite::after, &#share-option::after {
            content: '';
            display: block;
            float: right;
            width: 5px;
            height: 8px;
            margin-top: 10px;
            //background: url('~image/favoriteBox/more.svg') no-repeat;
          }
          &:hover,
          &#favorite.hover{
            background: #F6F7FA;
          }
        }
        li:first-child{
          border-top: none!important;
        }
        hr{
          height:1px;
          border:none;
          border-top:1px solid #eee;
        }
      }
    }
    .card-mode{
      height: 232px;
      .file-icon{
        width: 80px;
        height: 80px;
        margin: 35px calc(50% - 40px);
        background-color: transparent;
        background-repeat: no-repeat;
        vertical-align: middle;
      }
      .edit-input {
        margin-top: 4px;
        margin-left: 10px;
        width: 250px;
      }
      a.display-name, .update-date-updator, .update-size, .recent-update-date, .recent-update-size{
        left: 12px;
      }
      a.display-name{
        top: 164px;
      }
      .file-absolute{
        top: 200px;
        left: 80px;
      }
      .update-date-updator, .recent-update-date{
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 80%;
        overflow: hidden;
        height: 16px;
        top: 186px;
        line-height: 14px;
        .update-creator{
          max-width: calc(80% - 110px);
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          display: inline-block;
          vertical-align: bottom;
          font-size: 12px;
        }
      }
      .update-size, .recent-update-size{
        top: 206px;
      }
      .update-size{
        display: block;
      }
      .card-mode-footer {
        height: 80px;
      }
      .file-operate{
        margin-top: 11px;
      }
      .more{
        position: relative;
      }
      span.virus-icon {
        border: 1px solid #ff1b43;
        border-radius: 2px;
        color: #ff1b43;
        font-size: 12px;
        height: 16px;
        line-height: 16px;
        padding: 0 4px;
        position: relative;
        top: 7px;
        left: 18px;
      }
    }
    .mode-panel-file:hover .favorite-icon, .filelist-item-inner:hover .favorite-icon {
      display: inline-block;
      visibility: visible;
    }
  }
  .isfolder-true{
    .display-name{
      width:110px;
    }
    .file-absolute{
      left: 180px;
    }
    .card-mode-rename-more{   //大图模式重命名时 ...样式修改
      position: relative;
      top: 19px;
    }
  }
}

//清楚浮动
.clearfloat {
  overflow: hidden;
  height:100%;
}

//不可预览没有下划线和小手
.no-preview{
  cursor: default !important;
  text-decoration: none;
}
</style>
